import { useEffect, useState } from 'react';
import { useEmployeeNamesService } from 'domain/shared/employee';
import type { EmployeeNameEn, EmployeeNamesByAlias } from './employeeName';

type EmployeeNameRecord = { alias?: string; nameEn?: EmployeeNameEn };

const indexByAlias = (records: EmployeeNameRecord[]): EmployeeNamesByAlias => {
  const map: EmployeeNamesByAlias = {};
  for (const r of records) {
    if (r?.alias) map[r.alias] = r.nameEn ?? {};
  }
  return map;
};

export const useEmployeeNamesByAliases = (aliases: string[]): EmployeeNamesByAlias => {
  const { getEmployeeNamesByAliases } = useEmployeeNamesService();
  const [namesByAlias, setNamesByAlias] = useState<EmployeeNamesByAlias>({});
  const normalizedAliases = Array.from(new Set(aliases.filter(Boolean)));
  const aliasesKey = normalizedAliases.join('|');

  useEffect(() => {
    if (normalizedAliases.length === 0) {
      setNamesByAlias({});
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const records = (await getEmployeeNamesByAliases(normalizedAliases)) as EmployeeNameRecord[];
        if (!cancelled) setNamesByAlias(indexByAlias(records ?? []));
      } catch {
        if (!cancelled) setNamesByAlias({});
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aliasesKey]);

  return namesByAlias;
};
